export default function OpeningTimesController(
  $translate,
  $scope,
  $stateParams,
  openingTimesService,
  timesService,
  NotificationService,
  WEEKDAYS,
) {
  var vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.isLoading = false;
  vm.openingTimes = [];
  vm.openingTimesUnsaved = [];
  vm.highestTimeRangeId = null;
  vm.daysInWeek = WEEKDAYS;
  vm.timePickerHourStep = 1;
  vm.timePickerMinuteStep = 15;

  vm.init = init;
  vm.flagAsUnsaved = flagAsUnsaved;
  vm.deleteOpeningTime = deleteOpeningTime;
  vm.addNewOpeningTime = addNewOpeningTime;
  vm.saveOpeningTimes = saveOpeningTimes;

  var listener = $scope.$on('merchant.tab.times.selected', vm.init);

  function init() {
    listener();
    getOpeningTimes();
  }

  function getOpeningTimes() {
    enableLoading();
    openingTimesService
      .getOpeningTimes(vm.merchantId)
      .then(groupByDays)
      .catch(function() {
        NotificationService.error('Error getting merchant opening times');
      })
      .finally(disableLoading);
  }

  function groupByDays(chunks) {
    var openingTimesForDay,
      timeRange,
      i = 1;
    vm.openingTimes = [];
    vm.daysInWeek.map(function(day) {
      openingTimesForDay = [];
      chunks.map(function(chunk) {
        if (chunk.day === day) {
          timeRange = timesService.getTimeRangeFromChunk(chunk);
          openingTimesForDay.push({
            id: i++,
            start: timeRange.start,
            end: timeRange.end,
          });
        }
      });
      vm.openingTimes.push({ day: day, valid: true, times: openingTimesForDay });
      vm.highestTimeRangeId = i;
    });
  }

  function deleteOpeningTime(id, day) {
    vm.openingTimes.map(function(openingTimesForDay) {
      openingTimesForDay.times = openingTimesForDay.times.filter(function(chunk) {
        return chunk.id !== id;
      });
    });
    flagAsUnsaved(day);
  }

  function addNewOpeningTime(day) {
    vm.openingTimes.map(function(openingTimesForDay) {
      if (openingTimesForDay.day === day) {
        openingTimesForDay.times.push({
          id: ++vm.highestTimeRangeId,
          start: moment().startOf('day'),
          end: moment().startOf('day'),
        });
        flagAsUnsaved(day);
      }
    });
  }

  function saveOpeningTimes() {
    var chunks = buildChunksForApi();
    clearInvalidChunks();
    if (!chunksAreValid(chunks.openingScheduleChunkList)) {
      NotificationService.error('There are invalid times. Please review and try again');
      return;
    }
    openingTimesService
      .updateOpeningTimes(vm.merchantId, chunks)
      .then(function() {
        NotificationService.success('Opening hours successfully updated');
      })
      .then(getOpeningTimes)
      .then(clearUnsavedFlags)
      .catch(handleSaveError);
  }

  function buildChunksForApi() {
    var chunks = [],
      chunkTimes;
    vm.openingTimes.map(function(openingTimesForDay) {
      openingTimesForDay.times.map(function(chunk) {
        chunk = timesService.adjustNextDayOverflow(chunk);
        chunkTimes = timesService.getChunkTimesFromTimeRange(chunk);
        chunks.push({ day: openingTimesForDay.day, start: chunkTimes.start, end: chunkTimes.end });
      });
    });
    return { openingScheduleChunkList: chunks };
  }

  function chunksAreValid(chunks) {
    var chunksAreValid = true;
    chunks.map(function(chunk) {
      if (isNaN(chunk.start) || isNaN(chunk.end)) {
        vm.openingTimes.map(function(openingTimesForDay) {
          if (openingTimesForDay.day === chunk.day) {
            openingTimesForDay.valid = false;
          }
        });
        chunksAreValid = false;
      }
    });
    return chunksAreValid;
  }

  function handleSaveError(res) {
    var output,
      errorMessages = [];
    if (res && res.data && res.data.errors) {
      res.data.errors.map(function(error) {
        vm.openingTimes.map(function(openingTimesForDay) {
          if (openingTimesForDay.day === error.value) {
            openingTimesForDay.valid = false;
          }
        });
        if (error.message) {
          errorMessages.push($translate.instant(error.message));
        }
      });
    }
    output = errorMessages.length ? errorMessages.join('; ') : 'Error saving portal times';
    NotificationService.error(output);
  }

  function clearInvalidChunks() {
    vm.openingTimes.map(function(openingTimesForDay) {
      openingTimesForDay.valid = true;
    });
  }

  function flagAsUnsaved(day) {
    vm.openingTimesUnsaved[day] = true;
  }

  function clearUnsavedFlags() {
    vm.daysInWeek.map(function(day) {
      vm.openingTimesUnsaved[day] = false;
    });
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/opening-times/opening-times.controller.js